import { onWordTemplateActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { WordTemplateActivityCard } from "./WordTemplateActivityCard";
import { useCurrentUser } from "common/SessionContext";

interface Props {
  wordTemplateId: number
  fileId: string
  config: server.dto.ActivityPanelConfig
}

export const WordTemplateActivityPanel = (props: Props) => {
  const currentUser = useCurrentUser();
  const [fileId, setFileId] = React.useState<string>(props.fileId);

  return <ActivityPanel<server.dto.WordTemplateActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.WordTemplate.ListActivity({ itemId: props.wordTemplateId, page, perPage })}
    renderActivity={(activity => <WordTemplateActivityCard
      currentFileId={fileId}
      setCurrentFileId={setFileId}
      key={activity.activityId}
      activity={activity}
    />)}
    onActivityRegisterFn={onWordTemplateActivity}
    onActivity={(activity) => {
      if (activity.action.value === "uploadedNewFile") {
        setFileId(activity.fileId);
      }

      if (activity.itemId !== props.wordTemplateId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}